import { render, staticRenderFns } from "./PoliticaCookie.vue?vue&type=template&id=5a926778"
import script from "./PoliticaCookie.vue?vue&type=script&lang=js"
export * from "./PoliticaCookie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/leodev/Sistemas/loja/components/ButtonComponent.vue').default})
